// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Selected column header - Dark Green */
@font-face {
  font-family: "Semi Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Regular Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Medium Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Bold Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-display: swap;
}
.handsontable-output-terminal-section {
  border-top: 1px solid var(--border-color);
  height: 40vh;
}

.ht_clone_top .ht__highlight {
  background-color: var(--accent-primary-green-color) !important; /* Dark Green */
  color: var(--primary-surface-color) !important;
}

/* Selected column cells - Light Green */
td.ht__highlight {
  background-color: var(--excel-grid-bg) !important; /* Light Green */
}

/* Override Selection Area Background Color */
.handsontable td.area::before,
.handsontable td.area-1::before,
.handsontable td.area-2::before,
.handsontable td.area-3::before,
.handsontable td.area-4::before,
.handsontable td.area-5::before,
.handsontable td.area-6::before,
.handsontable td.area-7::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--excel-grid-bg) !important; /* Light Green */
}

.handsontable td.highlight.area {
  border-left: 1px solid var(--accent-primary-green-color) !important; /* Dark Green Border */
  border-right: 1px solid var(--accent-primary-green-color) !important; /* Dark Green Border */
  border-bottom: 1px solid var(--accent-primary-green-color) !important;
}

.handsontable th {
  background-color: var(--excel-grid-bg) !important;
  color: var(--primary-text-color) !important;
}

.handsontable .wtBorder.current {
  background-color: var(--accent-primary-green-color) !important;
}

.handsontable .wtBorder.area {
  background-color: unset !important;
  border: 1px solid var(--accent-primary-green-color);
  background-color: var(--accent-primary-green-color) !important;
}

/* Override Active Highlighted Column and Row Headers */
.handsontable tbody th.ht__active_highlight,
.handsontable thead th.ht__active_highlight {
  background-color: var(--accent-primary-green-color) !important; /* Dark Green */
  color: var(--primary-surface-color) !important; /* White Text */
  font-weight: bold;
}

.handsontableInput {
  box-shadow: 0 0 0 2px var(--accent-primary-green-color) inset !important;
}

/* ==============================
   Show Dropdown Only on Hover
   ============================== */
/* Hide dropdown by default */
.handsontable .changeType {
  visibility: hidden !important; /* Hide dropdown initially */
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

/* Show dropdown when hovering over the header */
.handsontable th:hover .changeType,
.handsontable th:focus-within .changeType {
  visibility: visible !important;
  opacity: 1;
}

.handsontable th,
.handsontable td {
  background-color: var(--primary-surface-color);
  color: var(--primary-text-color);
}

/* Show dropdown when hovering over a selected column */
.handsontable .ht__highlight:hover .changeType {
  visibility: visible !important;
  opacity: 1;
}

.handsontable .htDimmed {
  color: var(--primary-text-color);
}

.handsontable .changeType {
  border: unset !important;
  background: unset !important;
}

.handsontable .htUIInput.htUIButtonOK input {
  color: var(--primary-text-color) !important;
}

.handsontable .htUIInput input {
  color: var(--primary-text-color) !important;
}

.ht_master .wtHolder {
  scrollbar-width: none;
}

.handsontable .ht_master table td.htCustomMenuRenderer {
  background: var(--primary-surface-color) !important;
}

.htDropdownMenu table tbody tr td {
  background: var(--primary-surface-color) !important;
}

.handsontable .htUISelectCaption {
  background: var(--primary-surface-color) !important;
}

.htFiltersConditionsMenu table tbody tr td {
  background: var(--primary-surface-color) !important;
}

.handson-table-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  overflow: auto;
  width: 100%;
  border-right: 1px solid var(--border-color);
  background: var(--primary-surface-color);
}
.handson-table-section__excel-sandbox {
  display: flex;
  height: 50px;
  padding: 0px 20px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-bottom: 1px solid var(--border-color);
  background: var(--secondary-surface-color);
}
.handson-table-section__excel-sandbox.not-tabs {
  padding: 0px 20px 0px 0px;
}
@media (max-width: 900px) {
  .handson-table-section__excel-sandbox.not-tabs {
    padding: 0px 20px 0px 0px;
  }
}

.SplitPane .Resizer {
  height: 4px;
  cursor: row-resize;
  background: var(--border-color);
  position: relative;
  z-index: 10;
}
.SplitPane .Resizer:hover {
  background-color: #5095fc;
}

.SplitPane {
  position: unset !important;
}

.submission-report {
  display: flex;
  padding: 16px 24px;
  align-items: center;
  align-self: stretch;
  border-bottom: 1px solid var(--border-color);
}
.submission-report__score {
  color: var(--tertiary-text-color);
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 125%; /* 17.5px */
}
.submission-report__total-score {
  color: #5095fc;
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
}

.handson-sort {
  display: flex;
  width: 620px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 20px;
  border: 1px solid var(--border-color);
  background: var(--primary-surface-color);
}
.handson-sort__header {
  display: flex;
  padding: 20px 24px;
  border-radius: 20px 20px 0 0;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-bottom: 1px solid var(--border-color);
  background: var(--custom-tab-header-quiz);
}
.handson-sort__header-title {
  color: var(--primary-text-color);
  /* New Typeface/Heading 2 */
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 20px */
}
.handson-sort__header-cross {
  width: 18px;
  height: 18px;
  cursor: pointer;
  color: var(--primary-text-color);
}
.handson-sort__section {
  display: flex;
  padding: 28px;
  flex-direction: column;
  align-items: center;
  gap: 28px;
  align-self: stretch;
  border-bottom: 1px solid var(--border-color);
  background: var(--primary-surface-color);
}
.handson-sort__filters {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
}
.handson-sort__dropdowns {
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
}
.handson-sort__label-pair {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;
  width: 100%;
}
.handson-sort__dropdown-label {
  color: var(--primary-text-color);
  /* New Typeface/Sub Heading 3 */
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%; /* 17.5px */
}
.handson-sort__columns-dropdown {
  display: flex;
  padding: 8px 20px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: var(--quartinary-surface-color);
}
.handson-sort__checkbox-container {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.handson-sort__checkbox {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background: var(--accent-primary-blue-color);
}
.handson-sort__checkbox-label {
  color: var(--primary-text-color);
  /* New Typeface/Sub Heading 3 */
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%; /* 17.5px */
}
.handson-sort__ctas-container {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
}
.handson-sort__ok-button {
  cursor: pointer;
  display: flex;
  padding: 16px 0px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 8px;
  background: var(--accent-primary-blue-color);
  color: var(--primary-surface-color);
  text-align: center;
  /* New Typeface/CTA primary */
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%; /* 20px */
}
.handson-sort__cancel-button {
  cursor: pointer;
  display: flex;
  padding: 16px 0px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 8px;
  border: 1px solid var(--accent-primary-blue-color);
  background: var(--primary-surface-color);
  color: var(--accent-primary-blue-color);
  text-align: center;
  /* New Typeface/CTA primary */
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%; /* 20px */
}
.handson-sort__error {
  font-size: 12px;
  color: var(--accent-primary-red-color);
  padding-left: 2px;
}

.button-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/components/HandsonTableParent/handsonTable.scss","webpack://./src/styles/fonts.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAAA,wCAAA;ACAA;EACE,wBAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ADCF;ACEA;EACE,2BAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ADDF;ACGA;EACE,0BAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ADFF;ACIA;EACE,wBAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ADHF;AArBA;EACE,yCAAA;EACA,YAAA;AAuBF;;AArBA;EACE,8DAAA,EAEc,eAAA;EACd,8CAAA;AAsBF;;AAnBA,wCAAA;AACA;EACE,iDAAA,EAAA,gBAAA;AAsBF;;AAnBA,6CAAA;AACA;;;;;;;;EAQE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA,EAAA,gBAAA;AAsBF;;AAnBA;EACE,mEAAA,EAAA,sBAAA;EACA,oEAAA,EAAA,sBAAA;EACA,qEAAA;AAsBF;;AAnBA;EACE,iDAAA;EACA,2CAAA;AAsBF;;AAnBA;EACE,8DAAA;AAsBF;;AAnBA;EACE,kCAAA;EACA,mDAAA;EACA,8DAAA;AAsBF;;AAnBA,uDAAA;AACA;;EAEE,8DAAA,EAEc,eAAA;EACd,8CAAA,EAAA,eAAA;EACA,iBAAA;AAoBF;;AAjBA;EACE,wEAAA;AAoBF;;AAjBA;;mCAAA;AAIA,6BAAA;AACA;EACE,6BAAA,EAAA,4BAAA;EACA,UAAA;EACA,oCAAA;AAmBF;;AAhBA,gDAAA;AACA;;EAEE,8BAAA;EACA,UAAA;AAmBF;;AAhBA;;EAEE,8CAAA;EACA,gCAAA;AAmBF;;AAjBA,uDAAA;AACA;EACE,8BAAA;EACA,UAAA;AAoBF;;AAlBA;EACE,gCAAA;AAqBF;;AAnBA;EACE,wBAAA;EACA,4BAAA;AAsBF;;AAnBA;EACE,2CAAA;AAsBF;;AAnBA;EACE,2CAAA;AAsBF;;AAnBA;EAGE,qBAAA;AAoBF;;AAlBA;EACE,mDAAA;AAqBF;;AAnBA;EACE,mDAAA;AAsBF;;AApBA;EACE,mDAAA;AAuBF;;AArBA;EACE,mDAAA;AAwBF;;AAtBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,2CAAA;EACA,wCAAA;AAyBF;AAvBE;EACE,aAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,4CAAA;EACA,0CAAA;AAyBJ;AAvBI;EACE,yBAAA;AAyBN;AE7EE;EFmDE;IAGI,yBAAA;EA2BN;AACF;;AAtBA;EACE,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,WAAA;AAyBF;AAvBE;EACE,yBAAA;AAyBJ;;AArBA;EACE,0BAAA;AAwBF;;AArBA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,4CAAA;AAwBF;AArBE;EACE,iCAAA;EEjJF,oCAAA;EACA,kBAAA;EACA,gBAAA;EFiJE,eAAA;EACA,iBAAA,EAAA,WAAA;AAyBJ;AAtBE;EACE,cAAA;EExJF,oCAAA;EACA,kBAAA;EACA,gBAAA;EFwJE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA0BJ;;AAtBA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qCAAA;EACA,wCAAA;AAyBF;AAvBE;EACE,aAAA;EACA,kBAAA;EACA,4BAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,4CAAA;EACA,yCAAA;AAyBJ;AAtBE;EACE,gCAAA;EAEA,2BAAA;EExLF,oCAAA;EACA,kBAAA;EACA,gBAAA;EFyLE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AAwBJ;AArBE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gCAAA;AAuBJ;AApBE;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,4CAAA;EACA,wCAAA;AAsBJ;AAnBE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAqBJ;AAlBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAoBJ;AAjBE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AAmBJ;AAhBE;EACE,gCAAA;EAEA,+BAAA;EEpPF,sCAAA;EACA,kBAAA;EACA,gBAAA;EFqPE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAkBJ;AAfE;EACE,aAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qCAAA;EACA,2CAAA;AAiBJ;AAdE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAgBJ;AAbE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4CAAA;AAeJ;AAZE;EACE,gCAAA;EAEA,+BAAA;EExRF,sCAAA;EACA,kBAAA;EACA,gBAAA;EFyRE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAcJ;AAXE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAaJ;AAVE;EACE,eAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,4CAAA;EACA,mCAAA;EACA,kBAAA;EAEA,6BAAA;EEhTF,oCAAA;EACA,kBAAA;EACA,gBAAA;EFiTE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AAYJ;AATE;EACE,eAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,kDAAA;EACA,wCAAA;EACA,uCAAA;EACA,kBAAA;EAEA,6BAAA;EEvUF,oCAAA;EACA,kBAAA;EACA,gBAAA;EFwUE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AAWJ;AARE;EACE,eAAA;EACA,sCAAA;EACA,iBAAA;AAUJ;;AANA;EACE,mBAAA;EACA,YAAA;AASF","sourcesContent":["/* Selected column header - Dark Green */\n@import '../..//styles/styles.scss';\n\n.handsontable-output-terminal-section {\n  border-top: 1px solid var(--border-color);\n  height: calc(40vh);\n}\n.ht_clone_top .ht__highlight {\n  background-color: var(\n    --accent-primary-green-color\n  ) !important; /* Dark Green */\n  color: var(--primary-surface-color) !important;\n}\n\n/* Selected column cells - Light Green */\ntd.ht__highlight {\n  background-color: var(--excel-grid-bg) !important; /* Light Green */\n}\n\n/* Override Selection Area Background Color */\n.handsontable td.area::before,\n.handsontable td.area-1::before,\n.handsontable td.area-2::before,\n.handsontable td.area-3::before,\n.handsontable td.area-4::before,\n.handsontable td.area-5::before,\n.handsontable td.area-6::before,\n.handsontable td.area-7::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--excel-grid-bg) !important; /* Light Green */\n}\n\n.handsontable td.highlight.area {\n  border-left: 1px solid var(--accent-primary-green-color) !important; /* Dark Green Border */\n  border-right: 1px solid var(--accent-primary-green-color) !important; /* Dark Green Border */\n  border-bottom: 1px solid var(--accent-primary-green-color) !important;\n}\n\n.handsontable th {\n  background-color: var(--excel-grid-bg) !important;\n  color: var(--primary-text-color) !important;\n}\n\n.handsontable .wtBorder.current {\n  background-color: var(--accent-primary-green-color) !important;\n}\n\n.handsontable .wtBorder.area {\n  background-color: unset !important;\n  border: 1px solid var(--accent-primary-green-color);\n  background-color: var(--accent-primary-green-color) !important;\n}\n\n/* Override Active Highlighted Column and Row Headers */\n.handsontable tbody th.ht__active_highlight,\n.handsontable thead th.ht__active_highlight {\n  background-color: var(\n    --accent-primary-green-color\n  ) !important; /* Dark Green */\n  color: var(--primary-surface-color) !important; /* White Text */\n  font-weight: bold;\n}\n\n.handsontableInput {\n  box-shadow: 0 0 0 2px var(--accent-primary-green-color) inset !important;\n}\n\n/* ==============================\n   Show Dropdown Only on Hover\n   ============================== */\n\n/* Hide dropdown by default */\n.handsontable .changeType {\n  visibility: hidden !important; /* Hide dropdown initially */\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out;\n}\n\n/* Show dropdown when hovering over the header */\n.handsontable th:hover .changeType,\n.handsontable th:focus-within .changeType {\n  visibility: visible !important;\n  opacity: 1;\n}\n\n.handsontable th,\n.handsontable td {\n  background-color: var(--primary-surface-color);\n  color: var(--primary-text-color);\n}\n/* Show dropdown when hovering over a selected column */\n.handsontable .ht__highlight:hover .changeType {\n  visibility: visible !important;\n  opacity: 1;\n}\n.handsontable .htDimmed {\n  color: var(--primary-text-color);\n}\n.handsontable .changeType {\n  border: unset !important;\n  background: unset !important;\n}\n\n.handsontable .htUIInput.htUIButtonOK input {\n  color: var(--primary-text-color) !important;\n}\n\n.handsontable .htUIInput input {\n  color: var(--primary-text-color) !important;\n}\n\n.ht_master .wtHolder {\n  // overflow-y: auto;\n  // overflow-x: hidden;\n  scrollbar-width: none;\n}\n.handsontable .ht_master table td.htCustomMenuRenderer {\n  background: var(--primary-surface-color) !important;\n}\n.htDropdownMenu table tbody tr td {\n  background: var(--primary-surface-color) !important;\n}\n.handsontable .htUISelectCaption {\n  background: var(--primary-surface-color) !important;\n}\n.htFiltersConditionsMenu table tbody tr td {\n  background: var(--primary-surface-color) !important;\n}\n.handson-table-section {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  overflow: auto;\n  width: 100%;\n  border-right: 1px solid var(--border-color);\n  background: var(--primary-surface-color);\n\n  &__excel-sandbox {\n    display: flex;\n    height: 50px;\n    padding: 0px 20px;\n    justify-content: space-between;\n    align-items: center;\n    align-self: stretch;\n    border-bottom: 1px solid var(--border-color);\n    background: var(--secondary-surface-color);\n\n    &.not-tabs {\n      padding: 0px 20px 0px 0px;\n      @include respond-to(900px) {\n        padding: 0px 20px 0px 0px;\n      }\n    }\n  }\n}\n\n.SplitPane .Resizer {\n  height: 4px;\n  cursor: row-resize;\n  background: var(--border-color);\n  position: relative;\n  z-index: 10;\n\n  &:hover {\n    background-color: #5095fc;\n  }\n}\n\n.SplitPane {\n  position: unset !important;\n}\n\n.submission-report {\n  display: flex;\n  padding: 16px 24px;\n  align-items: center;\n  align-self: stretch;\n  border-bottom: 1px solid var(--border-color);\n  // background-size: contain;\n  // background: linear-gradient(0deg, rgba(255, 255, 255, 0.40) 0%, rgba(255, 255, 255, 0.40) 100%), linear-gradient(274deg, #C2D5FF -17.2%, #D7FFF8 136.15%);\n  &__score {\n    color: var(--tertiary-text-color);\n    @include SemiSans;\n    font-size: 14px;\n    line-height: 125%; /* 17.5px */\n  }\n\n  &__total-score {\n    color: #5095fc;\n    @include SemiSans;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 125%;\n  }\n}\n\n.handson-sort {\n  display: flex;\n  width: 620px;\n  flex-direction: column;\n  align-items: flex-start;\n  border-radius: 20px;\n  border: 1px solid var(--border-color);\n  background: var(--primary-surface-color);\n\n  &__header {\n    display: flex;\n    padding: 20px 24px;\n    border-radius: 20px 20px 0 0;\n    justify-content: space-between;\n    align-items: center;\n    align-self: stretch;\n    border-bottom: 1px solid var(--border-color);\n    background: var(--custom-tab-header-quiz);\n  }\n\n  &__header-title {\n    color: var(--primary-text-color);\n\n    /* New Typeface/Heading 2 */\n    // font-family: 'General Sans';\n    @include SemiSans;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 100%; /* 20px */\n  }\n\n  &__header-cross {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    color: var(--primary-text-color);\n  }\n\n  &__section {\n    display: flex;\n    padding: 28px;\n    flex-direction: column;\n    align-items: center;\n    gap: 28px;\n    align-self: stretch;\n    border-bottom: 1px solid var(--border-color);\n    background: var(--primary-surface-color);\n  }\n\n  &__filters {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 20px;\n    align-self: stretch;\n  }\n\n  &__dropdowns {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    align-self: stretch;\n  }\n\n  &__label-pair {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    gap: 8px;\n    flex: 1 0 0;\n    width: 100%;\n  }\n\n  &__dropdown-label {\n    color: var(--primary-text-color);\n\n    /* New Typeface/Sub Heading 3 */\n    // font-family: 'General Sans';\n    @include MediumSans;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 125%; /* 17.5px */\n  }\n\n  &__columns-dropdown {\n    display: flex;\n    padding: 8px 20px;\n    justify-content: space-between;\n    align-items: center;\n    align-self: stretch;\n    border-radius: 8px;\n    border: 1px solid var(--border-color);\n    background: var(--quartinary-surface-color);\n  }\n\n  &__checkbox-container {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  &__checkbox {\n    width: 20px;\n    height: 20px;\n    border-radius: 4px;\n    background: var(--accent-primary-blue-color);\n  }\n\n  &__checkbox-label {\n    color: var(--primary-text-color);\n\n    /* New Typeface/Sub Heading 3 */\n    // font-family: 'General Sans';\n    @include MediumSans;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 125%; /* 17.5px */\n  }\n\n  &__ctas-container {\n    display: flex;\n    align-items: flex-start;\n    gap: 24px;\n    align-self: stretch;\n  }\n\n  &__ok-button {\n    cursor: pointer;\n    display: flex;\n    padding: 16px 0px;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    flex: 1 0 0;\n    border-radius: 8px;\n    background: var(--accent-primary-blue-color);\n    color: var(--primary-surface-color);\n    text-align: center;\n\n    /* New Typeface/CTA primary */\n    // font-family: 'General Sans';\n    @include SemiSans;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 125%; /* 20px */\n  }\n\n  &__cancel-button {\n    cursor: pointer;\n    display: flex;\n    padding: 16px 0px;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    flex: 1 0 0;\n    border-radius: 8px;\n    border: 1px solid var(--accent-primary-blue-color);\n    background: var(--primary-surface-color);\n    color: var(--accent-primary-blue-color);\n    text-align: center;\n\n    /* New Typeface/CTA primary */\n    // font-family: 'General Sans';\n    @include SemiSans;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 125%; /* 20px */\n  }\n\n  &__error {\n    font-size: 12px;\n    color: var(--accent-primary-red-color);\n    padding-left: 2px;\n  }\n}\n\n.button-disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n","@font-face {\n  font-family: 'Semi Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf')\n    format('truetype');\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Regular Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Regular.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Regular.otf')\n    format('truetype');\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Medium Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Medium.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Medium.otf')\n    format('truetype');\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Bold Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Bold.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Bold.otf')\n    format('truetype');\n  font-display: swap;\n}\n","@mixin flex($direction: row, $align-items: center, $justify-content: center) {\n  display: flex;\n  flex-direction: $direction;\n  align-items: $align-items;\n  justify-content: $justify-content;\n}\n\n@mixin container {\n  margin: auto;\n  max-width: 1920px;\n}\n\n@mixin s_container {\n  max-width: 1536px;\n  margin: 0 auto;\n  padding: 0 32px;\n\n  @include l_desktop {\n    max-width: 1320px;\n  }\n\n  @include s_tablet {\n    padding: 0 16px;\n  }\n}\n\n@mixin box($width, $height: $width) {\n  width: $width;\n  height: $height;\n}\n\n// FONT ISSUE NOT MATCHING NEED TO GRAB NEW FONTS\n@mixin RegularSans {\n  font-family: 'Regular Sans', sans-serif;\n  font-style: normal;\n}\n@mixin MediumSans {\n  font-family: 'Medium Sans', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n}\n@mixin SemiSans {\n  font-family: 'Semi Sans', sans-serif;\n  font-style: normal;\n  font-weight: 600;\n}\n@mixin BoldSans {\n  font-family: 'Bold Sans', sans-serif;\n  font-style: normal;\n  font-weight: 700;\n}\n@mixin IBMPlexMonoMedium {\n  font-family: 'IBM Plex Mono', monospace;\n  font-weight: 500;\n  font-style: normal;\n}\n\n\n@mixin auth-heading {\n  @include Playfair;\n  line-height: 1.875rem;\n  font-weight: 600;\n  letter-spacing: -3%;\n  font-size: 2rem;\n  @include s_tablet {\n    font-size: 1.8rem;\n  }\n}\n\n@mixin auth-subheading {\n  @include Inter;\n  line-height: 1.875rem;\n  font-weight: 400;\n  font-size: 1rem;\n  @include s_tablet {\n    font-size: 0.9rem;\n  }\n}\n@mixin validation-text {\n  color: #ff0000;\n  font-size: 0.875rem;\n}\n\n@mixin input-placeholder {\n  &.placeholder {\n    @content;\n  }\n  &:-moz-placeholder {\n    @content;\n  }\n  &::-moz-placeholder {\n    @content;\n  }\n  &:-ms-input-placeholder {\n    @content;\n  }\n  &::-webkit-input-placeholder {\n    @content;\n  }\n}\n\n@mixin respond-to($max-width) {\n  @media (max-width: $max-width) {\n    @content;\n  }\n}\n@mixin respond-to-min($max-width) {\n  @media (min-width: $max-width) {\n    @content;\n  }\n}\n\n@mixin respond-to-height($max-height) {\n  @media (max-height: $max-height) {\n    @content;\n  }\n}\n\n@mixin larger_desktop {\n  @media (min-width: 1920px) {\n    @content;\n  }\n}\n@mixin l_desktop {\n  @media (min-width: 1536px) {\n    @content;\n  }\n}\n\n@mixin sm_desktop {\n  @media (max-width: 1350px) {\n    @content;\n  }\n}\n\n@mixin m_desktop {\n  @media (max-width: 1199px) {\n    @content;\n  }\n}\n\n@mixin s_desktop {\n  @media (max-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin l_tablet {\n  @media (max-width: 991px) {\n    @content;\n  }\n}\n\n@mixin m_tablet {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm_tablet {\n  @media (min-width: 601px) and (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin s_tablet {\n  @media (max-width: 550px) {\n    @content;\n  }\n}\n@mixin l_mobile {\n  @media (max-width: 425px) {\n    @content;\n  }\n}\n@mixin m_mobile {\n  @media (max-width: 375px) {\n    @content;\n  }\n}\n@mixin s_mobile {\n  @media (max-width: 350px) {\n    @content;\n  }\n}\n@mixin xs_mobile {\n  @media (max-width: 300px) {\n    @content;\n  }\n}\n@mixin safari_specific_style {\n  @supports (-webkit-touch-callout: none) {\n    @content;\n  }\n}\n@mixin hide_scrollbar {\n  /* Hide scrollbar for Chrome, Safari and Opera */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* Hide scrollbar for IE, Edge and Firefox */\n  & {\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n}\n\n@mixin underline_animation {\n  overflow: hidden;\n  background: linear-gradient(currentColor 0 0) 0 100% / var(--d, 0) 1px\n    no-repeat;\n  transition: 0.5s;\n  &:hover {\n    --d: 100%;\n  }\n}\n\n@mixin bounceInRight($duration: 0.5s) {\n  @-webkit-keyframes bounceInRight {\n    0% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n    100% {\n      -webkit-transform: translateX(0);\n    }\n  }\n  -webkit-animation-duration: $duration;\n  animation-duration: $duration;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  @keyframes bounceInRight {\n    0% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n    100% {\n      -webkit-transform: translateX(0);\n    }\n  }\n}\n\n@mixin bounceOutRight($duration: 0.5s) {\n  @-webkit-keyframes bounceOutRight {\n    20% {\n      opacity: 1;\n      -webkit-transform: translateX(-10px);\n    }\n    100% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n  }\n\n  @keyframes bounceOutRight {\n    20% {\n      opacity: 1;\n      transform: translateX(-10px);\n    }\n    100% {\n      opacity: 0;\n      transform: translateX(2000px);\n    }\n  }\n\n  -webkit-animation-duration: $duration;\n  animation-duration: $duration;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@mixin remove_userTapColor {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n@mixin ellipsis($line: 4) {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: $line; /* Set the number of lines to be shown */\n  -webkit-box-orient: vertical;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
